<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/sms-inbox-for-client-work.mjs";
</script>
